<template>
  <div class="order-list">
    <el-card class="query-card">

      <el-descriptions
        :column="3"
        border
        :title="$t('merchant.merchantInfo')"
      >
        <el-descriptions-item :label="$t('merchant.merNo')">
          {{ merchantInfo.merNo1 }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merName')">
          {{ merchantInfo.merName }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merArea')" >
          {{ merchantInfo.merArea == 1 ? $t('merchant.overseas') : (merchantInfo.merArea == 2 ? $t('merchant.domestic') : merchantInfo.merArea) }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('merchant.busId')" >
          {{ $i18n.locale === 'zh-CN' ? merchantInfo.busNameCn : merchantInfo.busNameEn }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merCerType')" >
          {{
            merchantInfo.merCerType == 1
              ? $t('merchant.idCard')
              : (merchantInfo.merCerType == 2 ? $t('merchant.tradingCertificate') : '')
          }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merCerNo')" >
          {{ merchantInfo.merCerNo }}
        </el-descriptions-item>


        <el-descriptions-item :label="$t('merchant.merState')" >
          {{ merchantInfo.merState }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merCity')" >
          {{ merchantInfo.merCity }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merAddress')" >
          {{ merchantInfo.merAddress }}
        </el-descriptions-item>

        <el-descriptions-item :label="$t('merchant.merLinkman')" >
          {{ merchantInfo.merLinkman }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merLinkphone')" >
          {{ merchantInfo.merLinkphone }}
        </el-descriptions-item>
        <el-descriptions-item  :label="$t('merchant.merFax')" >
          {{ merchantInfo.merFax }}
        </el-descriptions-item>


        <el-descriptions-item :label="$t('merchant.gwStatus')" >
          {{ $t(`merchant.status.code_${merchantInfo.merStatus}`) }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merWebsite')"  >
          {{ merchantInfo.merWebsite }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merEmail')" >
          {{ merchantInfo.merEmail }}
        </el-descriptions-item>


        <el-descriptions-item :label="$t('merchant.merTradedays')" >
          {{ $t('merchant.dayFormat', { num: merchantInfo.merTradedays || 0 }) }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merReservedays')" >
          {{ $t('merchant.dayFormat', { num: merchantInfo.merReservedays || 0 }) }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merUploadtype')" >
          {{ $t(`merchant.merUploadtype${merchantInfo.merUploadtype}`) }}
        </el-descriptions-item>


        <el-descriptions-item :label="$t('merchant.merRegdate')" >
          {{ merchantInfo.merRegdate }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merPactstdate')" >
          {{ merchantInfo.merPactstdate }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('merchant.merPactendate')" >
          {{ merchantInfo.merPactendate }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <div class="action-toolbar">

      <el-button
        v-if="hasPermission('merchant/showMerchantDetails', 'gateWay_update')"
        :disabled="!hasSearched"
        :loading="updateLoading"
        @click="handleUpdate"
        type="primary"
        icon="el-icon-edit"
      >
        {{ $t('button.update') }}
      </el-button>

    </div>

    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

        <el-table-column width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio
              v-model="selectedRowId"
              :label="scope.row.gwId"
              @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>


<!--        <el-table-column prop="gwId"  label="选择" :min-width="columnWidths.hkbatchNo"></el-table-column>-->


        <el-table-column :label="$t('merchant.gwNo')" :min-width="columnWidths.gwNo">
          <template slot-scope="scope">
            <span>{{ scope.row.gwNo1 || scope.row.gwNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gwMd5key"  :label="$t('merchant.gwMd5key')" :min-width="columnWidths.gwMd5key"></el-table-column>

        <el-table-column :label="$t('merchant.gwStatus')" :min-width="columnWidths.gwStatus">
          <template slot-scope="scope">
            <span v-if="scope.row.gwStatus == '-1'">{{ $t('merchant.mer_status_stop') }}</span>
            <span v-else-if="scope.row.gwStatus == '0'">{{ $t('merchant.mer_status_nonactivated') }}</span>
            <span v-else-if="scope.row.gwStatus == '1'">{{ $t('merchant.mer_status_normal') }}</span>
            <span v-else-if="scope.row.gwStatus == '2'">{{ $t('merchant.mer_status_test') }}</span>
            <span v-else-if="scope.row.gwStatus == '-2'">{{ $t('merchant.mer_status_del') }}</span>
            <span v-else>
              {{ $t('statusUnknown') }} ({{ scope.row.gwStatus }})
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchant.gwInfType')" :min-width="columnWidths.gwInfType">
          <template slot-scope="scope">
            <span v-if="scope.row.gwInfType == '0'">{{ $t('merchant.no_infrace') }}</span>
            <span v-else-if="scope.row.gwInfType == '1'">{{ $t('merchant.twofive_infrace') }}</span>
            <span v-else-if="scope.row.gwInfType == '2'">{{ $t('merchant.two_infrace') }}</span>
            <span v-else-if="scope.row.gwInfType == '3'">{{ $t('merchant.three_infrace') }}</span>
            <span v-else>
              {{ $t('statusUnknown') }} ({{ scope.row.gwInfType }})
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="gwCreatetime"  :label="$t('merchant.gwCreatetime')" :min-width="columnWidths.gwCreatetime"></el-table-column>




      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>


    <el-dialog
      :title="$t('button.updateKey')"
      :visible.sync="dialogVisible"
      width="450px"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="updateForm" label-width="80px">
        <el-form-item label="Key" prop="gwMd5key">
          <el-input
            v-model="form.gwMd5key"
            :placeholder="$t('button.updateKey')"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"> {{ $t('cancel') }}</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitUpdate">{{ $t('sure') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      loading: false,
      TraderecordRespVo: {
        startDate: "",
        endDate: "",
        hkbatchNo: "",

        sortField: undefined,
        sortOrder: undefined
      },

      merchantInfo:[],// 商户详细
      selectedRowData:"",// 当前行全部数据
      selectedRowId:"",// 选择id


      dialogVisible: false,      // 控制弹窗显示隐藏
      submitLoading: false,      // 确定按钮的加载状态
      form: {
        gwId: '',
        gwMd5key: '',     // 要修改的 key 值
        gwNo:''
      },

      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询

      updateLoading: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",

      rules: {
        gwMd5key: [
          { required: true, message: this.$t('button.keyCheckIserror'), trigger: 'blur' },
          { min: 8, max: 15, message: this.$t('button.keyCheckIserror'), trigger: 'blur' },
          { pattern: /^[A-Za-z0-9]{8,15}$/, message: this.$t('button.keyCheckIserror'), trigger: 'blur' }
        ]
      }
    };
  },
  created() {
     this.handleSearch(); // 初始化加载数据
    this.fetchMerchantInfo();
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  methods: {
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.TraderecordRespVo.sortField = undefined;
        this.TraderecordRespVo.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.TraderecordRespVo.sortField = prop;
        this.TraderecordRespVo.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },
    // 数据绑定
    handleRadioChange(row) {
      this.selectedRowData = row;
    },

    handleRowClick(row) {
      this.selectedRowId = row.gwId;
      this.selectedRowData = row;
    },


    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    // 商户详细信息
    async fetchMerchantInfo(){
      const res = await this.$axios.get('/api/merchant/info');
      if (res.data.code === 0) {
        const responseData = res.data.data;
        this.merchantInfo = responseData;

      } else {
        this.$message.error(res.data.msg);
        this.tableData = [];
        this.pagination.total = 0;
      }
    },
    // 查询列表
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/gateway/merlist',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },

    handleUpdate() {
      if (!this.selectedRowData) {
        this.$message.warning(this.$t('alert_select'));
        return;
      }

      this.form.gwId = this.selectedRowData.gwId || this.selectedRowData.tsId;
      this.form.gwMd5key = this.selectedRowData.gwMd5key || '';
      this.form.gwNo = this.selectedRowData.gwNo;

      this.dialogVisible = true;
    },
    async submitUpdate() {
      // 1.检查 ref 是否存在
      if (!this.$refs.updateForm) return;

      // 2. 执行校验
      this.$refs.updateForm.validate(async (valid) => {
        if (!valid) {
          this.$message.warning(this.$t('button.keyCheckIserror'));
          return false;
        }

        // 3. 行确认弹窗
        try {
          await this.$confirm(this.$t('button.gwCheckUpdatedecalre'), '提示', {
            confirmButtonText: this.$t('sure'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          });

          // 4. 确认后开始提交
          this.submitLoading = true;

          const params = {
            gwId : this.form.gwId,
            gwMd5key:this.form.gwMd5key,
            gwNo:this.form.gwNo
          };

          const res = await this.$axios.put('/api/gateway/update',  params );
          // await new Promise(resolve => setTimeout(resolve, 1000));

          if (res.data.code === 0){
            this.$message.success(this.$t('succeed'));
            this.dialogVisible = false;
            // console.log('清空前 gwMd5key:', this.selectedRowData.gwMd5key);
            this.selectedRowId = '';
            this.selectedRowData = null;

            this.fetchOrderList(); // 刷新列表

            // 加 await，等待列表真正刷新完成
            // await this.fetchOrderList();
            // const updatedRow = this.tableData.find(item => item.gwId === params.gwId);
            // if (updatedRow) {
            //   this.selectedRowId = updatedRow.gwId;
            //   this.selectedRowData = updatedRow;
            // }
            // console.log('清空后 gwMd5key:', this.selectedRowData.gwMd5key);

          }else {
            this.$message.error(res.data.msg);
          }

        } catch (error) {
          if (error === 'cancel') {
            this.$message.info(this.$t('cancel'));
          } else {
            this.$message.error(this.$t('requestFailed'));
          }
        } finally {
          this.submitLoading = false;
        }
      });
    },




    closeMoreDialog() {
      this.moreDialogVisible = false;
      this.currentField = null;
      this.moreInput = '';
    },

    onMoreDialogClose() {
      this.closeMoreDialog();
    },

    // 表头宽度
    initColumnWidths() {
      const cols = [
        'gwNo',
        'gwMd5key',
        'gwStatus',
        'gwInfType',
        'gwCreatetime',
        'choose',
      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `merchant.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

/*顶部*/
/*/deep/ .el-descriptions-item__label {
  text-align: center !important;
}

/deep/ .el-descriptions-item__content {
  text-align: center !important;
}*/

</style>



// WEBPACK FOOTER //
// src/view/merchant/showMerchantDetails.vue